export default "__VITE_ASSET__Da1RJmIR__"